import type { SxProps, Theme } from '@mui/material/styles';

import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

// ----------------------------------------------------------------------

type Props = {
  sx?: SxProps<Theme>;
};

/** Sektion under inloggningsformuläret för den som saknar konto — samma kort som formuläret. */
export function RegistreraKontoSektion({ sx }: Props) {
  return (
    <Card
      sx={[
        { p: 4, display: 'flex', flexDirection: 'column', gap: 2 },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Typography variant="h5">Inget konto än?</Typography>
      <Typography variant="body2" color="text.secondary">
        Skapa ett konto för att komma igång med din förening.
      </Typography>

      <Button component={RouterLink} href={paths.REGISTRERA} variant="outlined" size="large" fullWidth>
        Registrera konto
      </Button>
    </Card>
  );
}
